import i18n from '../../i18n';

const formMessages = {
  requiredInput: i18n.t('errors.required_input'),
  incorrectCode: i18n.t('errors.incorrect_code'),
  isNotEqualEmails: i18n.t('errors.is_not_equal_emails'),
  isNotEqualPasswords: i18n.t('errors.is_not_equal_passwords'),
  promocodeDoNotExist: i18n.t('errors.promocode_do_not_exist'),
  emailIncorrect: i18n.t('errors.email_incorrect'),
  oldPasswordIsIncorrect: i18n.t('errors.old_password_is_incorrect'),
  minLenghtPassword: i18n.t('errors.min_length_password'),
  errorSignIn: i18n.t('errors.error_sign_in'),
  maxLenghtPassword: i18n.t('errors.max_length_password'),
  userHasExisted: i18n.t('errors.user_has_existed'),
  tooManyRequests: i18n.t('errors.too_many_requests'),
  serviceIntegrationError: i18n.t('errors.service_integration_error'),
  emailDoNotRegistrated: i18n.t('errors.email_do_not_registrated'),
  userHasAccountOfficialSite: i18n.t('errors.user_has_account_official_site'),
  validatePattern: i18n.t('errors.validate_pass'),
  userDoesNotHaveRecurrent: i18n.t('errors.user_does_not_have_recurrent'),
  somethingGoneWrong: i18n.t('errors.something_went_wrong'),
}

const styles = {
  btnOpacityClass: 'button_modal-opacity',
  redSpinnerClass: 'spinner_red',
  whiteSpinnerClass: 'spinner_white',
}

export { formMessages, styles }
